module.exports = __webpack_public_path__ + "static/media/cmdb-reports.1d9d31b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/cmdb-reports.svg
// module id = 1108
// module chunks = 49